import { styled } from '@mui/material/styles'

const Container = styled('div')`
  position: absolute;
  top: 2rem;
  right: 2rem;
`

export { Container }
